import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, inject, DOCUMENT } from '@angular/core';
// Using ES6 import syntax
import hljs from 'highlight.js/lib/core';
import typescript from 'highlight.js/lib/languages/typescript';
import xml from 'highlight.js/lib/languages/xml';
import bash from 'highlight.js/lib/languages/bash';
import sql from 'highlight.js/lib/languages/sql';
import dos from 'highlight.js/lib/languages/dos';
import * as i0 from "@angular/core";
// styles are loaded separately, see libs\common\theme\frontend\src\global\_highlightjs.scss
// Then register the languages you need
hljs.registerLanguage('javascript', typescript);
hljs.registerLanguage('typescript', typescript);
hljs.registerLanguage('json', typescript);
hljs.registerLanguage('html', xml);
hljs.registerLanguage('xml', xml);
hljs.registerLanguage('bash', bash);
hljs.registerLanguage('sh', bash);
hljs.registerLanguage('sql', sql);
hljs.registerLanguage('batchfile', dos);
hljs.registerLanguage('bat', dos);
hljs.registerLanguage('cmd', dos);
// export interface HljsCache {
// 	hljs:HLJSApi
// }
// let cache:HljsCache = null
// let loadingPromise:Promise<HljsCache> = null
// const languagesToLoad = ['typescript','html','bash','sh','sql','json','batchfile']
// export function loadHighlightJs() {
// 	if(cache) {
// 		return Promise.resolve(cache)
// 	} else if(loadingPromise) {
// 		return loadingPromise
// 	}
// 	loadingPromise = import('highlight.js/lib/core').then(hljsModule=>{
// 		if(!hljsModule) throw new Error('failed to load highlight.js core.')
// 		const hljs:HLJSApi = hljsModule.default;
// 		return Promise.all(languagesToLoad.map(languageName => {
// 			return import('highlight.js/lib/languages/typescript').then(langModule=>{
// 				if(langModule.default) {
// 					hljs.registerLanguage(languageName, langModule.default)
// 				}
// 			})
// 		})).then(()=>{
// 			return hljs
// 		})
// 	}).then((hljs)=>{
// 		cache = {hljs};
// 		loadingPromise = null;
// 		return cache		
// 	})
// 	return loadingPromise
// }
export let HighlightJsService = /*#__PURE__*/(() => {
  class HighlightJsService {
    constructor() {
      this.document = inject(DOCUMENT);
      this.isPlatformBrowser = isPlatformBrowser(inject(PLATFORM_ID));
    }
    highlightText(content, language) {
      return hljs.highlight(content, {
        language
      }).value;
    }
    highlightElement(element) {
      return hljs.highlightElement(element);
    }
    static {
      this.ɵfac = function HighlightJsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HighlightJsService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HighlightJsService,
        factory: HighlightJsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return HighlightJsService;
})();